import { t } from "@impero-com/common/utils/i18n";
import { queryClient } from "@impero-com/common/utils/query_client";
import { emitNotification } from "@impero-com/ui";

import {
    getGetUsersUserIdPushReportsRecipientQueryKey,
    usePatchUsersUserIdPushReportsRecipient,
} from "api/generated/users/users";

import { invalidateAssignmentCountQuery } from "./useAssignmentCountQuery";

export function useUpdatePushReportRecipientForUserMutation() {
    return usePatchUsersUserIdPushReportsRecipient({
        mutation: {
            onSuccess: async (_data, { userId }) => {
                emitNotification(
                    "success",
                    t("User_PushReports_PushReports_Updated")
                );
                await Promise.all([
                    queryClient.invalidateQueries({
                        queryKey:
                            getGetUsersUserIdPushReportsRecipientQueryKey(
                                userId
                            ),
                    }),
                    invalidateAssignmentCountQuery(userId.toString()),
                ]);
            },
        },
    });
}
